import { render, staticRenderFns } from "./TodayStatistics.vue?vue&type=template&id=58bea4e7&scoped=true&"
import script from "./TodayStatistics.vue?vue&type=script&lang=js&"
export * from "./TodayStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TodayStatistics.vue?vue&type=style&index=0&id=58bea4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bea4e7",
  null
  
)

export default component.exports